const MIN_MINUTES = 0;
const MAX_MINUTES = 1439;

/**
 * Converts a slider value (minutes from midnight) to a 4-char "HHMM" string.
 * e.g., 0 → "0000", 60 → "0100", 720 → "1200", 1439 → "2359"
 */
const minutesToHHMM = (minutes) => {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${String(h).padStart(2, '0')}${String(m).padStart(2, '0')}`;
};

/**
 * Converts a "HHMM" string to minutes from midnight.
 * e.g., "0000" → 0, "0100" → 60, "1200" → 720, "2359" → 1439
 */
const hhmmToMinutes = (hhmm) => {
  if (!hhmm || hhmm.length < 4) return null;
  const h = parseInt(hhmm.substring(0, 2), 10);
  const m = parseInt(hhmm.substring(2, 4), 10);
  return h * 60 + m;
};

/**
 * Converts slider range [startMinutes, endMinutes] to API time window string "HHMM_HHMM".
 * Returns undefined if the range is full day (no filter needed).
 */
const sliderToTimeWindow = (startMin, endMin) => {
  if (startMin === MIN_MINUTES && endMin === MAX_MINUTES) return undefined;
  return `${minutesToHHMM(startMin)}${minutesToHHMM(endMin)}`;
};

/**
 * Parses an API time window string "HHMM_HHMM" to [startMinutes, endMinutes].
 * Returns [0, 1439] if null/undefined (full day).
 */
const timeWindowToSlider = (timeWindow) => {
  if (!timeWindow || timeWindow.length < 8) return [MIN_MINUTES, MAX_MINUTES];
  const start = hhmmToMinutes(timeWindow.substring(0, 4));
  const end = hhmmToMinutes(timeWindow.substring(4, 8));
  return [start ?? MIN_MINUTES, end ?? MAX_MINUTES];
};

/**
 * Checks if the slider is at its full range (= "Anytime" / no filter).
 */
const isFullDayRange = (start, end) => start === MIN_MINUTES && end === MAX_MINUTES;

export {
  MIN_MINUTES,
  MAX_MINUTES,
  minutesToHHMM,
  hhmmToMinutes,
  sliderToTimeWindow,
  timeWindowToSlider,
  isFullDayRange,
};
